// extracted by mini-css-extract-plugin
export default {"selectorLanguage":"_7kLJV","languageItem":"CcaK9","active":"ROCJB"};